import { render, staticRenderFns } from "./people-contact.vue?vue&type=template&id=55dc41fc&"
import script from "./people-contact.vue?vue&type=script&lang=js&"
export * from "./people-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports